import InviteBtn from './InviteBtn';
import { twMerge } from 'tailwind-merge';
import { useRouter } from 'next/router';
import { SyntheticEvent, useMemo } from 'react';
import { useGroupOrder } from '@/store/group-order';
import useTranslation from 'next-translate/useTranslation';
import CancelBtn from './CancelBtn';
import PointsBackLabel from './PointsBackLabel';
import BackBtn from './BackBtn';
import { WeeeIcon } from '@/components/common/Icon';

export default function GroupOrderHeader(props: {
  className?: string;
  showInvite: boolean;
  shareInfo?: any;
  vendorTitle: string;
  showBackBtn?: boolean;
}) {
  const { className, showBackBtn, showInvite, shareInfo, vendorTitle } = props;
  const { intervalGroupOrderData } = useGroupOrder();
  const { t } = useTranslation('groupOrder');
  const router = useRouter();

  const isHost = useMemo(() => {
    if (!intervalGroupOrderData) return false;
    return intervalGroupOrderData?.is_creator || false;
  }, [intervalGroupOrderData]);

  const groupInfo = (
    <div className="text-surface-100-bg flex flex-col">
      <div
        data-testid="wid-group-order-info"
        className={twMerge('text-surface-100-bg enki-body-base-medium', 'text-left line-clamp-1')}>
        {t('group_order_owner_title', {
          userName: intervalGroupOrderData?.user_name || ''
        })}
      </div>
      {isHost && <PointsBackLabel theme="black" className="mt-200" />}
    </div>
  );

  const renderInviteBtn = () => {
    if (showInvite && isHost) {
      return (
        <div className="flex-none flex flex-row">
          <InviteBtn shareInfo={shareInfo} isHost={isHost} />
          <CancelBtn isHost={isHost} intervalGroupOrderData={intervalGroupOrderData} />
        </div>
      );
    }
    if (showInvite && !isHost) {
      return (
        <div className="flex-none flex flex-row">
          <InviteBtn shareInfo={shareInfo} isHost={isHost} />
        </div>
      );
    }
    return <div className="h-1 w-16"></div>;
  };

  const handleBack = (e: SyntheticEvent) => {
    e?.stopPropagation();
    router.back();
  };

  if (!intervalGroupOrderData) {
    return <div className="h-[68px]"></div>;
  }

  if (showBackBtn) {
    return (
      <div
        data-com="GroupOrderHeader"
        className={twMerge('h-[68px] flex flex-row items-center justify-between pl-2 pr-4', className)}>
        <div className="flex flex-row items-center">
          <WeeeIcon
            onClick={e => handleBack(e)}
            className="pr-2 text-reserved-true-white"
            style={{ fontSize: 28 }}
            type="iconBack"
          />
          {groupInfo}
        </div>
        {renderInviteBtn()}
      </div>
    );
  }

  return (
    <div
      data-testid="mod-group-order-header"
      data-com="GroupOrderHeader"
      className={twMerge('h-[68px] flex flex-row items-center justify-between px-2.5', className)}>
      <div className="text-surface-100-bg flex flex-row items-center">
        <BackBtn isHost={isHost} vendorTitle={vendorTitle} intervalGroupOrderData={intervalGroupOrderData} />
        {groupInfo}
      </div>
      {renderInviteBtn()}
    </div>
  );
}
